<template>
  <v-container>
    <SearchForm />

    <v-row v-if="displaySearchResults">
      <v-col cols="12" class="text-center pt-0">
        <SearchResultsWrapper v-if="!noResults" />
        <div v-else>No Results</div>
      </v-col>
    </v-row>
  </v-container>
</template>

<style>
</style>

<script>
import SearchForm from '@/components/Search/SearchForm';
import SearchResultsWrapper from '@/components/Search/SearchResultsWrapper';

import { mapState, mapActions } from 'vuex';

export default {
  components: {
    SearchForm,
    SearchResultsWrapper
  },
  computed: {
    ...mapState('search', ['displaySearchResults', 'searchResults']),
    environment () {
      return localStorage.getItem('environment');
    },
    noResults () {
      return this.searchResults.length === 0;
    }
  },
  mounted () {
    this.setActiveClientTab(0);
  },
  methods: {
    ...mapActions(['setActiveClientTab'])
  }
};
</script>
